import { http } from "@/api";

/**
 * Solicita todas as plantas hidroelétricas de uma empresa.
 * @param {Number} companyId Id da empresa detentora do ativo.
 * @returns Array com as plantas hidroelétricas disponíveis da empresa.
 */
const GetList = function(companyId)
{
	return http.get(`/HydroPowerPlants?companyId=${companyId}`);
};

/**
 * Solicita todas as unidades geradoras de uma planta hidroelétrica.
 * @param {Number} monitoringElementId Id do elemento de monitoração do tipo planta hidroelétrica.
 * @returns Array com as unidade geradoras filha da planta hidroelétrica solicitada.
 */
const GetGeneratingUnits = function(monitoringElementId)
{
	return http.get(`/HydroPowerPlants/${monitoringElementId}/HydroGeneratingUnits`);
};

/**
 * Solicita as notificações geradas para as unidades geradoras da planta.
 * @param {Number} notificationsParams Id do elemento de monitoramento tipo planta hidroelétrica.
 * @returns Array com notificações geradas para as unidades geradoras da planta.
 */
const GetNotificationsLogs = function(notificationsParams)
{
	return http.get(`/HydroPowerPlants/
		${notificationsParams.monitoringElementId }/notifications-log?startDateTime=
		${notificationsParams.startDateTime}&endDateTime=
		${notificationsParams.endDateTime}`);
};

export default
{
	GetList, GetGeneratingUnits, GetNotificationsLogs
};